import { Controller } from "@hotwired/stimulus"

// Shows the survey email's copy only while one of the email-style channels (Survey::EMAILED_CHANNELS) is picked, and
// opens the channel picker from the page help's "Turn on the survey".
export default class extends Controller {
  static targets = ["select", "emailSection"]
  static values = { emailed: Array }

  toggle() {
    const channels = Array.from(this.selectTarget.selectedOptions, (option) => option.value)
    this.emailSectionTarget.classList.toggle("hidden", !channels.some((channel) => this.emailedValue.includes(channel)))
  }

  open() {
    const picker = this.selectTarget.tomselect
    picker.wrapper.scrollIntoView({ block: "center", behavior: "smooth" })
    picker.focus()
  }
}
